export default {
  digitalOceanSpaces: "https://monuments.sfo2.digitaloceanspaces.com/",
  bucketName: "monuments"
};
